<template>
  <div :class="PostData.Post.bodyClass" v-if="PostData">
    <HeadBlock />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <div class="container">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <template v-if="PostData.Category">
            <li class="breadcrumb-item active" aria-current="page" v-if="[0, 1, 2].includes(PostData.Category.Type)">
              {{ $t('金曲獎') }}</li>
            <li class="breadcrumb-item active" aria-current="page" v-else>{{ $t('金曲國際音樂節') }}</li>
            <li class="breadcrumb-item active" aria-current="page"><router-link
                :to="{ name: 'Category', params: { CId: PostData.Category.CId } }">{{ PostData.Category.CategoryName
                }}</router-link></li>
          </template>
          <li class="breadcrumb-item active" aria-current="page">{{ PostData.Post.Title }}</li>
        </div>
      </ol>
    </nav>
    <a accesskey="c" id="accesskey_c" href="#" title="中間主要內容區">
      :::
    </a>

    <!-- 1 [入口頁]一般文章 -->
    <!-- 2 [金曲獎]首頁文章 -->
    <!-- 3 [金曲獎]一般文章 -->
    <template v-if="[0, 3].includes(PostData.Post.PMId)">
      <div class="main newsMain">
        <div class="container">
          <div class="title">
            <h2>{{ PostData.Post.Title }}</h2>
            <p class="time">{{ PostData.Post.PublicStartTime | timeString("YYYY-MM-DD") }}</p>
          </div>
          <div class="carousel_box" v-if="Slideshows">
            <div>
              <VueSlickCarousel :arrows="true" :dots="true">
                <div class="" v-for="(Slideshow, index) in Slideshows" :index="index">
                  <div class="img_box">
                    <img :src="PostData.SiteUrl + Slideshow.Url" :alt="Slideshow.DisplayName">
                  </div>
                  <p>{{ Slideshow.DisplayName }}</p>
                </div>
              </VueSlickCarousel>
            </div>
          </div>
          <div class="text_box" v-html="PostData.Post.Content">
          </div>
        </div>
      </div>
    </template>
    <!-- 4 [金曲獎]公告文章 -->
    <template v-if="[4].includes(PostData.Post.PMId)">
      <div class="main ticket notice">
        <div class="container" v-html="PostData.Post.Content">
        </div>
      </div>
    </template>
    <!-- 5 [金曲獎]歷屆得獎名單 -->
    <!-- 13 [金曲獎]點禮地點 -->
    <template v-if="[13].includes(PostData.Post.PMId)">
      <div class="main place">
        <div class="container" v-html="PostData.Post.Content">
        </div>
      </div>
    </template>
    <!-- 6 [音樂節]一般文章 -->
    <!-- 7 [音樂節]音樂專題/快速媒合會 -->
    <template v-if="[7].includes(PostData.Post.PMId)">
      <div class="main festivalConference">
        <div class="container">
          <div class="title_text">
            <!-- logo圖 -->
            <div class="img_box">
              <!-- <img :src="CategoryData.SiteLogo" alt="GMA logo" v-if="CategoryData.SiteLogo"> -->
              <img src="img/GMAlogo.svg" alt="GMA logo" v-if="PostData.SiteLogo">
              <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
            </div>
            <div class="text_box">
              <div class="title">
                <h2>{{ PostData.Post.Title }}</h2>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="content">
              <div v-html="PostData.Post.Content">
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 8 [音樂節]商展交易中心 -->
    <template v-if="[8].includes(PostData.Post.PMId)">
      <div class="main festivalBizMatching">
        <div class="container">
          <div class="title_text">
            <!-- logo圖 -->
            <div class="img_box">
              <!-- <img :src="PostData.SiteLogo" alt="GMA logo" v-if="PostData.SiteLogo"> -->
              <img src="img/GMAlogo.svg" alt="GMA logo" v-if="PostData.SiteLogo">
              <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
            </div>
            <!-- 大標題和文字框 -->
            <div class="text_box">
              <div class="title">
                <h2>{{ PostData.Post.Title }}</h2>
              </div>
              <div class="text">
                {{ PostData.Post.SimpleContent }}
              </div>
            </div>
          </div>
          <div class="box" v-html="PostData.Post.Content">
          </div>
        </div>
      </div>
    </template>
    <!-- 9 [音樂節]SHOWCASE售票演唱會 -->
    <!-- 10 [音樂節]金曲星聲代 -->
    <template v-if="[10].includes(PostData.Post.PMId)">
      <div class="main festivalPictureMain">
        <div class="container">
          <!-- <div class="title_text">
            <div class="img_box">
              <img :src="PostData.SiteLogo" alt="GMA logo" v-if="PostData.SiteLogo">
              <img src="img/logo_1.svg" alt="GMA logo" v-else>
            </div>
            <div class="text_box">
              <div class="title">
                <h2>{{ PostData.Post.Title }}</h2>
              </div>
              <div class="text">
                {{ PostData.Post.SimpleContent }}
              </div>
            </div>
          </div> -->
          <div class="box" v-html="PostData.Post.Content">
          </div>
        </div>
      </div>
    </template>
    <!-- 11 [音樂節]策略聯盟 -->
    <!-- 12 [音樂節]場地資訊 -->

    <FooterBlock v-if="PostData && [0, 3, 4, 13].includes(PostData.Post.PMId)" />
    <FestivalFooterBlock v-else />
  </div>
</template>
<script>
import HeadBlock from "@/components/HeadBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";
import FestivalFooterBlock from "@/components/FestivalFooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "金曲獎": "金曲獎",
    "金曲國際音樂節": "金曲國際音樂節",
  },
  en: {
    "首頁": "Home",
    "金曲獎": "Golden Melody Awards",
    "金曲國際音樂節": "Golden Melody Festival",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Post",
  i18n,
  components: {
    Slick,
    HeadBlock,
    FooterBlock,
    FestivalFooterBlock,
    VueSlickCarousel,
  },
  data() {
    return {
      PostData: null,
      Attachments: null,
      Slideshows: null,
      local: "zh_tw",
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchPostData(to.params.PId, to.params.CId);
    next();
  },
  created: function () {
    this.fetchPostData(this.$route.params.PId, this.$route.params.CId);
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    fetchPostData(PId, CId) {
      // Vue.axios
      //   .get(
      //     this.$store.state.src + this.$store.state.subDirectory + "/Html/Post",
      //     { params: { PId: PId, CId: CId } }
      //   )
      //   .then((response) => {
      //     this.PostData = response.data;
      //     // 附件處理
      //     if (this.PostData.Post.Attachment != "[]") {
      //       this.Attachments = JSON.parse(this.PostData.Post.Attachment);
      //     } else {
      //       this.Attachments = null;
      //     }
      //     // 幻燈片處理
      //     if (this.PostData.Post.Slideshow != "[]") {
      //       this.Slideshows = JSON.parse(this.PostData.Post.Slideshow);
      //     } else {
      //       this.Slideshows = null;
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
      fetch("/gma/36th/data/post/all/" + PId + ".json")
        .then(response => response.json())
        .then(data => {
          this.PostData = data;
          // 附件處理
          if (this.PostData.Post.Attachment != "[]") {
            this.Attachments = JSON.parse(this.PostData.Post.Attachment);
          } else {
            this.Attachments = null;
          }
          // 幻燈片處理
          if (this.PostData.Post.Slideshow != "[]") {
            this.Slideshows = JSON.parse(this.PostData.Post.Slideshow);
          } else {
            this.Slideshows = null;
          }
          if (CId) {
            fetch("/gma/36th/data/category/all/" + CId + ".json")
              .then(response_c => response_c.json())
              .then(data_c => {
                this.PostData.Category = data_c.Category;
              })
              .catch(error_c => {
                console.error("載入JSON失敗：", error_c);
              });
          }
        })
        .catch(error => {
          console.error("載入JSON失敗：", error);
        });
    }
  },
};
</script>